import React from 'react';
import Typography from '@material-ui/core/Typography';

const H1 = ({ children }: any) => <Typography variant="h1">{children}</Typography>;

export default H1;
